export default __webpack_public_path__ + "static/media/misc-bathtubA-480w.d5e562ab.png";